var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.players),function(player){return _c('div',{key:player._id},[(player && _vm.isAlive({ player }))?_c('CrystalShardOne',{attrs:{"player":player}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }